<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="preface">
<h1>Preface</h1>
<p>The preparation for this book started some years ago when I was planning my first trip to Casa de Dom Inácio which is a famous spiritual healing centre in Brazil. I had an idea back then that I would start a research study during the trip in which I would try to find out about the experiences of the people who had been to Casa. I was prepared to conduct interviews there but turned out to be too difficult to do for a number of reasons. However, I was able to recruit several people around the world to take part later in my study. After returning from my trip, I approached them via email and asked them to tell me about their experiences in Casa by using a form including several open questions. I continued collecting the data during the next year in Finland by conducting interviews for Casa visitors. One year later I started to analyse the data and to write the research report. At some point, I realised that there was enough data for a whole book. Beside the research results, I wanted to describe and tell many things related to the Casa in the coming book. I included also my personal experiences from three trips in it which hopefully add understanding of the phenomena existing in Casa area.</p>
<p>The long process that has led to creating this book is ending. I am very proud that in this book it is also possible to offer new scientific knowledge from Casa; no one has ever published qualitative research results about the people who have visited Casa before. The previous research done on the topic has been mainly short surveys. I believe that the new research results published in this book and the other parts of the book as well will open new perspectives to spirituality and will complete the already existing information about Casa de Dom Inácio.</p>
<p>To you, dear reader, I would like to wish an enjoyable and interesting reading journey with this book which has now been translated into English, also. The original version was published in Finnish.</p>
<p>In the beginning of the year 2019</p>
<p>Merja Sankelo</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?15ea6a6a